import { useEffect, useState } from 'react';
import { apiRequests } from '../../shared/api/apiRequests';
import { User } from '../../entities/User';
import { Link } from 'react-router-dom';
import { Pagination } from '../../features/Pagination/index.js';
import { PageBar } from '../../shared/ui/PageBar';

const UsersPage = () => {
  const [users, setUsers] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [count, setCount] = useState(0);

  const getData = (count = 10, offset = 0) => {
    apiRequests.users.get(count, offset).then((res) => {
      setUsers(res.items);
      setCount(res.totalCount);
    });
  };

  useEffect(() => {
    // getData()
  }, []);

  const handleSearch = () => {
    if (searchValue === '') {
      getData();
    } else {
      apiRequests.users.getFiltered(searchValue).then((res) => {
        setUsers(res.items);
      });
    }
  };

  const handleUpdate = () => {
    if (searchValue === '') {
      getData();
    } else {
      handleSearch();
    }
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск пользователей..."
        createLink="/users/create"
      />

      <div className="page-table mb-3">
        {users?.length === 0 ? (
          <p className={'text-center'}>По вашему запросу ничего не найдено</p>
        ) : (
          users && users.map((item) => <User onUpdate={handleUpdate} data={item} key={item.id} />)
        )}
      </div>

      <Pagination count={count} itemsPerPage={10} onChange={(page) => getData(10, 10 * page)} />
    </>
  );
};

export default UsersPage;
